webModule.controller('errorController',
    ['$scope','$rootScope', '$window',
        function ($scope, $rootScope, $window) {

            $scope.goPreviousView = function(){
                $window.history.back();
            };
        }]);
